/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// content types
import Quiz from 'material/embeds/content/contenttype/quiz/quiz_container';
import Poll from 'material/embeds/content/contenttype/poll/poll_container';
import Story from 'material/embeds/content/contenttype/story/story_container';
import EmailCollection from 'material/embeds/content/contenttype/emailcollection/emailcollection_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/content_styles';



/* ========== ~~~~~~~~~~ EMBED : CONTENT ~~~~~~~~~~ ========== */
class Content extends Component {
    displayUniqueContent() {
        switch (this.props.type) {
            case 'email':
                return <EmailCollection isEditable={this.props.isEditable}/>
            case 'quiz':
                return <Quiz contentId={this.props.contentId} isEditable={this.props.isEditable} />;
            case 'story':
                return <Story contentId={this.props.contentId} isEditable={this.props.isEditable} />;
            case 'poll':
            default:
                return <Poll contentId={this.props.contentId} isEditable={this.props.isEditable} />;
        }
    }
    backgroundImageCheckHelper = () => this.props.type === 'email' ? false : this.props.type === 'story' ? 'story' : 'questionBased';
    backgroundImageCheck = () => this.backgroundImageCheckHelper() && !!this.props.currentContentStatus[this.backgroundImageCheckHelper()].backgroundImageURL;
    render() {
        return(
            <div className={`content ${this.props.classes.content} ${this.props.location} editable-${this.props.isEditable} backgroundImage-${this.backgroundImageCheck()}`}>
                {this.displayUniqueContent()}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Content);
